import styled, { keyframes } from "styled-components";
import * as Defines from '../../utils/defines/defines'

export const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    background: ${Defines.BackgroundContainer};
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    padding: 20px 40px 40px 40px;
    box-sizing: border-box;
    position: relative;
    overflow-x: hidden;
    ${Defines.media.mobile`
        padding: 16px;
    `}
`

const drift = keyframes`
    0%, 100% { transform: translate(0, 0); }
    50% { transform: translate(36px, -26px); }
`

const spin = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
`

export const SpinnerIcon = styled.img`
    width: 16px;
    height: 16px;
    animation: ${spin} 0.8s linear infinite;
`

export const BgLights = styled.div`
    position: absolute;
    inset: 0;
    z-index: 0;
    overflow: hidden;
    pointer-events: none;
`

export const BlobFixedBlue = styled.div`
    position: absolute;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background: #5292D1;
    top: -100px;
    left: -60px;
    filter: blur(70px);
    opacity: 0.4;
    animation: ${drift} 10s ease-in-out infinite;
`

const alertasColor: Record<'ok' | 'atencao' | 'critico', { bg: string; opacity: number }> = {
    ok:      { bg: '#5292D1', opacity: 0.3 },
    atencao: { bg: '#E5D34A', opacity: 0.36 },
    critico: { bg: '#F03F3F', opacity: 0.48 },
}
const manutencaoColor: Record<'ok' | 'atencao' | 'critico', { bg: string; opacity: number }> = {
    ok:      { bg: '#92B258', opacity: 0.3 },
    atencao: { bg: '#E8A84C', opacity: 0.36 },
    critico: { bg: '#F03F3F', opacity: 0.48 },
}

export const BlobAlertas = styled.div<{severity: 'ok' | 'atencao' | 'critico'}>`
    position: absolute;
    width: 340px;
    height: 340px;
    border-radius: 50%;
    top: 16%;
    right: 4%;
    filter: blur(80px);
    animation: ${drift} 10s ease-in-out infinite 1.5s;
    background: ${props => alertasColor[props.severity].bg};
    opacity: ${props => alertasColor[props.severity].opacity};
    transition: background .7s ease, opacity .7s ease;
`

export const BlobManutencao = styled.div<{severity: 'ok' | 'atencao' | 'critico'}>`
    position: absolute;
    width: 340px;
    height: 340px;
    border-radius: 50%;
    bottom: 6%;
    left: 30%;
    filter: blur(80px);
    animation: ${drift} 10s ease-in-out infinite 3s;
    background: ${props => manutencaoColor[props.severity].bg};
    opacity: ${props => manutencaoColor[props.severity].opacity};
    transition: background .7s ease, opacity .7s ease;
`
export const HeaderBar = styled.div`
    min-height: 80px;
    width: 100%;
    flex-shrink: 0;
    background: ${Defines.GlassCardBg};
    border: ${Defines.GlassCardBorder};
    backdrop-filter: ${Defines.GlassCardBlur};
    box-shadow: ${Defines.GlassCardShadow};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    border-radius: 20px;
    padding: 14px 20px;
    box-sizing: border-box;
`

export const HeaderSubGroup = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;
    ${Defines.media.mobile`
        flex-direction: column;
    `}
`

export const TitleBlock = styled.div`
    display: flex;
    flex-direction: column;
`

export const Eyebrow = styled.p`
    margin: 0 0 2px;
    font-family: "Montserrat";
    font-weight: 700;
    font-size: 11px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(255,255,255,0.4);
`

export const UsinaTitle = styled.p`
    margin: 0;
    font-family: "Montserrat";
    font-weight: 800;
    font-size: 28px;
    color: #FFF;
`

export const MoendaButton = styled.button`
    cursor: pointer;
    background: rgba(82, 146, 209, 0.22);
    border: 1px solid rgba(82, 146, 209, 0.4);
    backdrop-filter: blur(10px);
    border-radius: 999px;

    height: 40px;
    padding: 0 20px;
    box-sizing: border-box;

    display: flex;
    justify-content: center;
    align-items: center;

    font-family: 'Nunito';
    font-weight: 700;
    font-size: 14px;
    color: #FFFFFF;

    :hover{
        transition: .2s;
        background: rgba(82, 146, 209, 0.32);
    }

`

export const Title = styled.p`
    margin: 0 0 8px 5px;
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 25px;
    color: ${Defines.TitleColor};
`

export const TernoTitle = styled.p`
    margin: 0px;
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 12px;
    color: ${Defines.TitleColor};
`


export const Nav = styled.div`
    height: 80px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: flex-start;
`

export const NavTitleContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

export const NavTitle = styled.p`
    margin: 0;
    font-family: "Montserrat";
    background: -webkit-linear-gradient(45deg, rgb(62, 147, 216), rgb(76, 185, 49));
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent; 
    font-weight: bold;
    font-size: 35px;
    letter-spacing: 1.5px;
`

export const TernosArea = styled.div`

    width: 100%;
    height: min-content;
    margin-bottom: 10px;

    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    ${Defines.media.mobile`
        width: 100%;
        height: auto;
    `}
`

export const GraficoArea = styled.div`

    width: 340px;
    background: ${Defines.GlassCardBg};
    border: ${Defines.GlassCardBorder};
    backdrop-filter: ${Defines.GlassCardBlur};
    box-shadow: ${Defines.GlassCardShadow};
    border-radius: 16px;
    padding: 14px;
    box-sizing: border-box;

    display:flex;
    flex-direction: column;

    ${Defines.media.mobile`
        width: 100%;
    `}
`

export const ManutencaoArea = styled.div`

    width: 100%;
    background: ${Defines.GlassCardBg};
    border: ${Defines.GlassCardBorder};
    backdrop-filter: ${Defines.GlassCardBlur};
    box-shadow: ${Defines.GlassCardShadow};
    border-radius: 20px;
    padding: 16px 20px;
    box-sizing: border-box;
    margin-bottom: 10px;

    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 14px 20px;

`

/**
 * Escala visual para leitura à distância (TV) — zoom reflui o layout (diferente de transform:scale).
 * O width é pré-encolhido pelo inverso do zoom: como o zoom amplia o footprint visual do elemento
 * (diferente de transform:scale), sem isso o conteúdo ultrapassaria a largura do monitor em 35%.
 */
export const TvScaleWrapper = styled.div<{tvMode: boolean}>`
    width: 100%;
    ${props => props.tvMode && `
        width: calc(100% / 1.35);
        zoom: 1.35;
    `}
`

export const AlertasArea = styled.div`

    width: 100%;
    height: 60vh;
    background: ${Defines.GlassCardBg};
    border: ${Defines.GlassCardBorder};
    backdrop-filter: ${Defines.GlassCardBlur};
    box-shadow: ${Defines.GlassCardShadow};
    border-radius: 16px;
    padding: 16px;
    box-sizing: border-box;
    overflow-y: auto;

    ${Defines.media.mobile`
        width: 100%;
        height: auto;
        max-height: 50vh;
        margin-left: 0;
        margin-top: 10px;
    `}
`

export const GradientContent = styled.div`
    width: 100%;
    padding-top: 2px;
    box-sizing: border-box;
`

export const MoendaText = styled.p`
    margin: 0;
    font-family: "Nunito";
    font-weight: 300;
    font-size: 16px;
    margin-bottom: 10px;
    color: rgba(255,255,255,0.8);
      -webkit-transition: 0.5s;
    -moz-transition: 0.5s;
    -o-transition: 0.5s;
    -ms-transition: 0.5s;
    transition: 0.5s
`

export const MoendaTitle = styled.p`
    margin: 0;
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 20px;
    transition: .5s;
    color: ${Defines.TitleColor};
`

export const GradientCenter = styled.div`
    width: 100%;
    height: 7px;
    border-radius: 7px;
    background: linear-gradient(90deg, #F03F3F 5%, #E5D34A 15%, #92B258 25%, #92B258 50%, #92B258 75%, #E5D34A 85%, #F03F3F 95%);
`

export const RailPickup = styled.div`
    position: relative;
    margin-top: -8px;
    width: calc(100% - 8px);
`

export const Pickup = styled.div<{left: number}>`
    top: 0;
    position: absolute;
    left: ${props => props.left}%;
`

export const CirclePickup = styled.div`
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: #FFF;
    box-shadow: 0 0 0 3px rgba(255,255,255,0.15), 0 2px 6px rgba(0,0,0,0.4);
`

export const TextPickup = styled.p`
    margin: 0;
    font-family: 'Nunito';
    font-size: 10px;
    color: #FFF;
    white-space: nowrap;
    margin-left: -30%;
`

export const GradientUmidade = styled.div`
    width: 100%;
    height: 7px;
    border-radius: 7px;
    background: linear-gradient(90deg, #92B258 40%, #E5D34A 41%, #E5D34A 60%, #F03F3F 61%);
`

export const GradientStart = styled.div`
    width: 100%;
    height: 7px;
    border-radius: 7px;
    background: linear-gradient(90deg, #92B258 20%, #E5D34A 25%, #E5D34A 43%, #F03F3F 48%);
`

// Autoteste da bomba: 0-4000psi vermelho, 4000-4400 amarelo, 4400-5200 verde, acima vermelho
// (escala do gauge de 0 a 6000psi) — ver AUTOTESTE_LIMITES em functions.tsx.
export const GradientAutoteste = styled.div`
    width: 100%;
    height: 7px;
    border-radius: 7px;
    background: linear-gradient(90deg, #F03F3F 66.67%, #E5D34A 66.67%, #E5D34A 73.33%, #92B258 73.33%, #92B258 86.67%, #F03F3F 86.67%);
`

export const FooterText = styled.p`
    margin: 0;
    font-family: "Nunito";
    font-weight: 300;
    font-size: 12px;
    color: rgba(255,255,255,0.8);
    -webkit-transition: 0.5s;
    -moz-transition: 0.5s;
    -o-transition: 0.5s;
    -ms-transition: 0.5s;
    transition: 0.5s
`

export const AlertText = styled.p`
    margin: 0 0 12px 0;
    font-family: "Nunito";
    font-weight: 300;
    font-size: 16px;
    color: rgba(255,255,255,0.8);
    -webkit-transition: 0.5s;
    -moz-transition: 0.5s;
    -o-transition: 0.5s;
    -ms-transition: 0.5s;
    transition: 0.5s
`

export const MultipleCharts = styled.div`
    width: 100%;
    height: 55%;
`

export const Row = styled.div`
    display: flex;
`